import React from "react";
import { FaUser } from "react-icons/fa";

/**
 * Single list row for a patient, used both in the conversed list and the
 * "all patients" search view. Both source endpoints already return a
 * consistent shape here ({ patientId, firstName, photoName }), so no
 * normalization step is needed (unlike the doctor-object mismatch on the
 * patient-side component).
 */
function PatientListItem({ patient, unreadCount, onClick }) {
  return (
    <div
      className="flex items-center border-b p-2 hover:bg-gray-100 cursor-pointer"
      onClick={onClick}
    >
      {(patient.photoName || patient.photo) ? (
        <img
          src={process.env.REACT_APP_IMAGE_URL + (patient.photoName || patient.photo)}
          alt={patient?.patientName || patient?.firstName}
          className="w-12 h-12 rounded-full"
        />
      ) : (
        <FaUser className="w-12 h-12 rounded-full text-blue-200" />
      )}
      <div className="ml-4 flex-1">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold flex items-center">{patient?.patientName || `${patient?.firstName} ${patient?.lastName ? patient?.lastName:''}`}</h3>
          {unreadCount > 0 && (
            <span className="min-w-5 max-w-max w-5 h-5 rounded-[50%] bg-brand-colorError text-white text-center">
              {unreadCount}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(PatientListItem);